import { useMessageSource } from "react-message-source";
import * as Yup from "yup";

export default function useEmailValidator(): Yup.StringSchema {
  const { getMessage } = useMessageSource();

  return Yup.string()
    .email(getMessage("Validation.message-email"))
    .required(getMessage("Validation.message-required"));
}
